import script from "./VFeedStoryRecordContentRenderer.vue?vue&type=script&lang=ts"
export * from "./VFeedStoryRecordContentRenderer.vue?vue&type=script&lang=ts"

import "./VFeedStoryRecordContentRenderer.vue?vue&type=style&index=0&id=fb86400e&lang=scss"

const __exports__ = script;

export default __exports__